<full-calendar [options]="calendarOptions" *ngIf="calendarVisible"></full-calendar>
